import axios from "@/libs/api.request";
// 获取列表
export const getPeakSeason = params => {
  return axios.request({
    url: "/finance/peak_season",
    method: "get",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/finance/peak_season/${id}`,
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: `/finance/peak_season`,
    method: "post",
    data
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/peak_season/${data.id}`,
    method: "put",
    data
  });
};

export const deleteItem = id => {
  return axios.request({
    url: `/finance/peak_season/${id}`,
    method: "delete"
  });
};

export const batchDel = data => {
  return axios.request({
    url: `/finance/peak_season/batchDel`,
    method: "post",
    data
  });
};
